import { render } from "./ProgramCard.vue?vue&type=template&id=20a7737e&scoped=true"
import script from "./ProgramCard.vue?vue&type=script&lang=js"
export * from "./ProgramCard.vue?vue&type=script&lang=js"

import "./ProgramCard.vue?vue&type=style&index=0&id=20a7737e&scoped=true&lang=css"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a7737e"]])

export default __exports__